import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { postGuestLogin, postConfirmGuestLogin, postResendSmsCode } from '../../lib/api';
import { getCountryPhoneByCode } from '../../lib/countries';
import { payWithCreditCard } from '../transfer/transferSlice';

export const sendSmsToSender = createAsyncThunk(
  'sender/sendSmsToSender',
  async ({ fullPhoneNumber, reCaptchaToken }) => {
    try {
      const response = await postGuestLogin({
        reCaptcha: reCaptchaToken,
        senderPhoneNumber: fullPhoneNumber,
      });

      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject();
    }
  }
);

export const verifyCode = createAsyncThunk(
  'sender/checkVerificationCode',
  async (code, { getState, dispatch }) => {
    try {
      const { tempToken, email } = getState().sender;

      const response = await postConfirmGuestLogin({ code, tempToken });

      dispatch(payWithCreditCard({ email, accessToken: response.accessToken }));
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject();
    }
  }
);

export const resendSmsCode = createAsyncThunk('sender/resendSms', async (_, { getState }) => {
  const { tempToken } = getState().sender;
  try {
    const response = await postResendSmsCode({ tempToken });

    return Promise.resolve(response);
  } catch (error) {
    return Promise.reject(error);
  }
});

const initialState = {
  email: '',
  countryCode: 'US',
  phoneNumber: '',
  fullPhoneNumber: '',
  tempToken: '',
};

const senderSlice = createSlice({
  name: 'sender',
  initialState,
  reducers: {
    setSendersEmail(state, action) {
      state.email = action.payload;
    },

    setSenderCountryCode(state, action) {
      state.countryCode = action.payload;

      if (state.phoneNumber) {
        const phoneExt = getCountryPhoneByCode(action.payload);

        state.fullPhoneNumber = `${phoneExt}${state.phoneNumber}`;
      }
    },

    setSenderPhoneNumber(state, action) {
      state.phoneNumber = action.payload;

      if (state.countryCode) {
        const phoneExt = getCountryPhoneByCode(state.countryCode);

        state.fullPhoneNumber = `${phoneExt}${action.payload}`;
      }
    },

    setSenderPhoneAndCountry(state, action) {
      state.countryCode = action.payload.countryCode;
      state.phoneNumber = action.payload.phoneNumber;

      const phoneExt = getCountryPhoneByCode(state.countryCode);

      state.fullPhoneNumber = `${phoneExt}${action.payload.phoneNumber}`;
    },
  },
  extraReducers: {
    [sendSmsToSender.fulfilled]: (state, action) => {
      state.tempToken = action.payload.tempToken;
    },
    [verifyCode.fulfilled]: (state) => {
      state.tempToken = '';
    },
  },
});

export const {
  setSendersEmail,
  setSenderCountryCode,
  setSenderPhoneNumber,
  setSenderPhoneAndCountry,
} = senderSlice.actions;

export default senderSlice.reducer;
